import React from 'react';

export const WashingtonInfo = () => (
    <div>
        <p className="eds-text-bl eds-l-mar-bot-4">City of Seattle</p>
        <p className="eds-l-mar-bot-1">
            <strong>Emergency Fund for Businesses</strong> |&nbsp;
            <a
                href="http://www.seattle.gov/office-of-economic-development/small-business/small-business-programs-/stabilization-fund-"
                target="_blank"
                rel="noopener noreferrer"
                className="eds-text-weight--heavy"
            >
                Apply
            </a>
        </p>
        <p>$1.5 million on grants of up to $10,000 to small businesses.</p>

        <p className="eds-text-bl eds-l-mar-bot-4 eds-l-mar-top-8">Amazon</p>
        <p className="eds-l-mar-bot-1">
            <strong>Neighborhood Small Business Relief Fund</strong> |&nbsp;
            <a
                href="https://www.aboutamazon.com/job-creation-and-investment/neighborhood-small-business-relief-fund#what-businesses-qualify-to-apply-for-the-neighborhood-small-business-relief-fund"
                target="_blank"
                rel="noopener noreferrer"
                className="eds-text-weight--heavy"
            >
                Apply
            </a>
        </p>
        <p>
            This fund is intended to help support neighborhood small businesses
            in Seattle (South Lake Union and Regrade neighborhoods) and
            Bellevue. Eligible small businesses need to have fewer than 50
            employees or less than $7 million in annual revenue, and be service
            or retail establishments open to the general public.
        </p>
    </div>
);
